import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { SPACING_UNIT, BREAKPOINTS } from './constants';
export var position = function position(pos, top, right, bottom, left) {
  return {
    position: pos,
    top: top,
    right: right,
    bottom: bottom,
    left: left
  };
};
export var size = function size(width, height) {
  return {
    width: width,
    height: height || width
  };
};
export var minSize = function minSize(width, height) {
  return {
    minWidth: width,
    minHeight: height || width
  };
};
export var maxSize = function maxSize(width, height) {
  return {
    maxWidth: width,
    maxHeight: height || width
  };
};
export var flex = function flex() {
  var alignItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'stretch';
  var justifyContent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'flex-start';
  return {
    display: 'flex',
    alignItems: alignItems,
    justifyContent: justifyContent
  };
};
export var edgeToEdgeMobileContent = function edgeToEdgeMobileContent() {
  return _defineProperty({}, BREAKPOINTS.down('sm'), {
    marginLeft: -3 * SPACING_UNIT,
    marginRight: -3 * SPACING_UNIT
  });
};
export var ellipsis = function ellipsis() {
  return {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordWrap: 'normal'
  };
};
export var unbuttonize = function unbuttonize() {
  return {
    appearance: 'none',
    backgroundColor: 'transparent',
    border: 0,
    padding: 0
  };
};
export default {
  position: position,
  size: size,
  minSize: minSize,
  maxSize: maxSize,
  flex: flex,
  ellipsis: ellipsis,
  unbuttonize: unbuttonize,
  edgeToEdgeMobileContent: edgeToEdgeMobileContent
};